import { useMemo } from 'react';

import { useComplianceExperience } from '~/hooks/useComplianceExperience';
import { useAppSelector } from '~/store/hooks/useAppSelector';

import { BUTTON_SUGGESTION, getButtonSuggestion } from './helpers';

export const useButtonSuggestion = (): BUTTON_SUGGESTION | null => {
  const { user_subscription, user_product, is_stripe_user } = useAppSelector(
    (state) => state.profile,
  );
  const experience = useComplianceExperience();

  return useMemo(
    () =>
      getButtonSuggestion({
        subStatus: user_subscription.status,
        regularity: user_product.regularity,
        isExtensionInstalled: Boolean(
          document.getElementById('justdone-content-app'),
        ),
        isStripeUser: is_stripe_user,
        complianceExperienceId: experience.id,
      }),
    [is_stripe_user, user_subscription, user_product, experience.id],
  );
};

export const useIsUpgradeSuggested = (): boolean =>
  useButtonSuggestion() === BUTTON_SUGGESTION.UPGRADE;
